export default __webpack_public_path__ + "static/media/2185.53e9f3af.png";